module.exports = __webpack_public_path__ + "img/查看全部外文期刊.033c596c.png";